/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ISpacerViewProps } from '@msdyn365-commerce-modules/spacer/dist/types';
import { ISpacerProps } from '../definition-extensions/spacer.ext.props.autogenerated';
import { VariantType, isMobile } from '@msdyn365-commerce-modules/utilities';


const SpacerView: React.FC<ISpacerViewProps & ISpacerProps<{}>> = (
    props: ISpacerViewProps & ISpacerProps<{}>
): JSX.Element => {
    const [isMobilePort, setIsMobile] = React.useState<boolean>(false);

    const isMobileViewport = React.useCallback(() => {
        const isMobileView = isMobile({ variant: VariantType.Browser, context: props.context.request }) === 'xs';
        setIsMobile(isMobileView);
    }, [props.context.request]);

    React.useEffect(() => {
        window.addEventListener('resize', isMobileViewport);
        isMobileViewport();
    }, [isMobileViewport]);


    return (
        <>
            {isMobilePort ?
                <div className={props.config.spacerHeightMobile ? `ms-${props.config.spacerHeightMobile}` : 'ms-spacer'} id={props.id} {...props.renderModuleAttributes(props)} /> :
                <div className={props.config.spacerHeight ? `ms-${props.config.spacerHeight}` : 'ms-spacer'} id={props.id} {...props.renderModuleAttributes(props)} />
            }</>
    )
}

export default SpacerView;
